<script setup>
import { TooltipTrigger } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: undefined },
  as: { type: [String, Object], default: undefined },
});
</script>

<template>
  <TooltipTrigger data-slot="tooltip-trigger" v-bind="props">
    <slot />
  </TooltipTrigger>
</template>
